export const selectAuthState = (state) => state.auth;
